import { useState } from "react";
import { Phone, MessageCircle, MessageSquare } from "lucide-react";

const intl = (phone) => {
  const d = String(phone || "").replace(/\D/g, "");
  if (!d) return null;
  return d.length === 10 ? `1${d}` : d;
};

export const QuickContact = ({ phone, templates, testid }) => {
  const [idx, setIdx] = useState(0);
  const num = intl(phone);
  if (!num) return null;
  const text = encodeURIComponent(templates[idx]?.text || "");
  const cls = "inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold border transition-colors duration-150";
  return (
    <div className="mt-2 space-y-1.5">
      <select value={idx} onChange={(e) => setIdx(Number(e.target.value))} data-testid={`${testid}-template`}
        className="w-full max-w-[220px] rounded-sm bg-navy border border-gold/30 px-2 py-1 text-[11px] text-slate-200 focus:border-gold outline-none">
        {templates.map((t, i) => <option key={t.label} value={i}>{t.label}</option>)}
      </select>
      <div className="flex flex-wrap gap-1.5">
        <a href={`tel:+${num}`} data-testid={`${testid}-call`} className={`${cls} border-sky-500/40 text-sky-300 hover:bg-sky-500/15`}><Phone className="h-3 w-3" /> Call</a>
        <a href={`https://wa.me/${num}?text=${text}`} target="_blank" rel="noopener noreferrer" data-testid={`${testid}-whatsapp`} className={`${cls} border-emerald-500/40 text-emerald-300 hover:bg-emerald-500/15`}><MessageCircle className="h-3 w-3" /> WhatsApp</a>
        <a href={`sms:+${num}?&body=${text}`} data-testid={`${testid}-sms`} className={`${cls} border-gold/40 text-gold hover:bg-gold/15`}><MessageSquare className="h-3 w-3" /> Text</a>
      </div>
    </div>
  );
};

const SIGN = "— Bridge Taxi, Airport Shuttle & Tours (902-440-7855)";

export const quoteTemplates = (q) => {
  const hi = `Hi ${q.name || "there"},`;
  const what = `request for ${q.service_type || "a ride"}${q.date ? ` on ${q.date}` : ""}`;
  return [
    { label: "Price reply", text: `${hi} thank you for your ${what}. The price is $____ (HST included). Shall I book it for you? ${SIGN}` },
    { label: "Need more details", text: `${hi} thanks for your ${what}! Could you confirm the pickup time, address and number of passengers so I can give you an exact price? ${SIGN}` },
    { label: "Booked / confirmed", text: `${hi} your ${q.service_type || "ride"}${q.date ? ` on ${q.date}` : ""} is booked and confirmed. We'll see you then! ${SIGN}` },
    { label: "Sorry, not available", text: `${hi} thank you for your ${what}. Unfortunately we are fully booked at that time. Could another time work for you? ${SIGN}` },
  ];
};

export const bookingTemplates = (b) => {
  const hi = `Hi ${b.name || "there"},`;
  const ref = b.id.slice(0, 8).toUpperCase();
  const when = [b.date, b.time].filter(Boolean).join(" at ");
  const drv = b.driver_name ? `${b.driver_name}${b.vehicle ? ` (${b.vehicle})` : ""}` : "your driver";
  return [
    { label: "Ride confirmed", text: `${hi} your ride ${ref}${when ? ` on ${when}` : ""} is confirmed${b.pickup ? `, pickup at ${b.pickup}` : ""}. ${SIGN}` },
    { label: "Driver details", text: `${hi} ${drv} will pick you up${when ? ` on ${when}` : ""}. ${SIGN}` },
    { label: "On my way", text: `${hi} ${drv} is on the way and will arrive shortly. ${SIGN}` },
    { label: "Arrived", text: `${hi} ${drv} has arrived${b.pickup ? ` at ${b.pickup}` : ""}. ${SIGN}` },
    { label: "Thank you + review", text: `${hi} thank you for riding with us! We'd love a quick review: ${window.location.origin}/review/${b.id} ${SIGN}` },
  ];
};
